import { mailRuTokenParam } from 'components/page/Boarding/Boarding.constants'

export const findMailRuToken = () => {
  const search = new URLSearchParams(location.search)
  return search.get(mailRuTokenParam)
}
